import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'
import moment from 'moment'

import { TextInput } from '../UI'

import { validateRequired } from './../../libs/validation'

class TravelerForm extends Component {
  static propTypes = {
    t: PropTypes.func,
    onFormFieldChange: PropTypes.func.isRequired,
    index: PropTypes.number,
    onDelete: PropTypes.func,
    traveler: PropTypes.shape({
      name: PropTypes.string,
      yearOfBirth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  }

  state = {
    displayAdditionalFields: false
  }

  onAgeChange(id, value) {
    const yearOfBirth = moment()
      .subtract(value, 'years')
      .year()

    this.props.onFormFieldChange(id, yearOfBirth)
  }

  toggleAdditionalFields() {
    this.setState({
      displayAdditionalFields: !this.state.displayAdditionalFields
    })
  }

  render() {
    const { t, onFormFieldChange, traveler, onDelete, index } = this.props
    const { displayAdditionalFields } = this.state

    return (
      <div className="row">
        <TextInput
          label={t('full_name_label')}
          labelClass="create-trip__form-label--default"
          wrapperClass="col-md-6"
          id="name"
          extraClass="form-control create-trip__form-input"
          placeholder={t('traveler_name_placeholder')}
          validationFuncs={[validateRequired]}
          initialValue={traveler.name}
          onChangeExternal={(id, value) => onFormFieldChange(id, value)}
        />

        <TextInput
          label={t('traveler_age')}
          labelClass="create-trip__form-label--default"
          wrapperClass="col-md-5"
          id="yearOfBirth"
          type="number"
          min={1}
          extraClass="form-control create-trip__form-input"
          placeholder={t('traveler_age')}
          initialValue={moment()
            .subtract(traveler.yearOfBirth, 'years')
            .year()}
          onChangeExternal={(id, value) => this.onAgeChange(id, value)}
        />

        <div className="form-group col-md-1" style={{ padding: '0' }}>
          <label className="create-trip__form-label--default">&nbsp;</label>
          <button className="remove-button" style={{ marginTop: '6px' }} onClick={() => onDelete(index)}>
            <i className="icon-delete" />
          </button>
        </div>

        <div className="col-md-12">
          <span onClick={this.toggleAdditionalFields.bind(this)}>Advanced fields</span>
        </div>

        {displayAdditionalFields &&
          (
            <div className="row">
              <TextInput
                label="Phone"
                labelClass="create-trip__form-label--default"
                wrapperClass="col-md-6"
                id="phone"
                extraClass="form-control create-trip__form-input"
                placeholder="Enter valid phone number"
                validationFuncs={[validateRequired]}
                initialValue={traveler.phone}
                onChangeExternal={(id, value) => onFormFieldChange(id, value)}
              />

              <TextInput
                label="Email"
                labelClass="create-trip__form-label--default"
                wrapperClass="col-md-5"
                id="email"
                type="email"
                extraClass="form-control create-trip__form-input"
                placeholder="Enter valid email"
                initialValue={traveler.email}
                onChangeExternal={(id, value) => this.onAgeChange(id, value)}
              />
            </div>
          )
        }
      </div>
    )
  }
}

export default compose(translate('create_trip'))(TravelerForm)



// WEBPACK FOOTER //
// src/components/CreateTripForm/TravelerForm.js